<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header"><h3>{{$t('pages.LoginForm')}}</h3></div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error" v-html="$t(error)">
                        </div>
                        <div class="alert alert-warning" v-if="expired">
                            {{$t('errorMessages.SESSION_EXPIRED')}}
                        </div>
                        <div class="alert alert-success" v-if="verifySuccess">
                          {{$t('verifyEmail.verifyTokenSuccess')}}
                        </div>
                        <form @submit.prevent="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="loginForm"/>
                            <button type="submit" class="btn btn-primary">{{ $t('button.Login') }}</button>
                            <router-link class="ml-3 btn btn-secondary" to="/register">
                                {{ $t('button.Register') }}
                            </router-link>
                            <router-link class="btn btn-link" to="/forgot-password">
                                {{ $t('button.ForgotPassword?') }}
                            </router-link>
                        </form>
                        <vue-recaptcha :sitekey="siteKey"
                                       @expired="onExpired"
                                       @verify="onVerify"
                                       ref="recaptcha"
                                       size="invisible">

                        </vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import isEmail from 'validator/lib/isEmail';
  import isLength from 'validator/lib/isLength';
  import { mapActions } from 'vuex';
  import { ERROR_MESSAGES, SITE_KEY_RECAPTCHA } from '../../constants';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'LoginForm',
    components: { VueRecaptcha },
    data() {
      return {
        error: '',
        form: {},
        siteKey: SITE_KEY_RECAPTCHA,
        model: {
          email: '',
          password: ''
        },
        fields: [
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Email')
            },
            required: true,
            validators: {
              validEmail: {
                expression(field, model, next) {
                  next(isEmail(model[field.key]));
                },
                message: 'Email nemá platný tvar'
              }
            }
          },
          {
            key: 'password',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Password'),
              inputType: 'password',
            },
            required: true,
            validators: {
              validPassword: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
        ]
      };
    },
    computed: {
      expired() {
        return !!this.$route.query.sessionExpired;
      },
      next() {
        return this.$route.params.next;
      },
      verifySuccess() {
        return this.$route.query['verify-success'];
      }
    },
    methods: {
      ...mapActions(['login', 'userInfo']),
      onVerify(response) {
        this.loginUser(response);
      },
      onExpired() {
        this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
      },
      submit() {
        this.error = null;
        this.$refs.loginForm.validate()
          .then(() => {
            if (!this.form.$valid) return;

            this.$refs.recaptcha.execute()
          })
          .catch((e) => {

          });
      },
      loginUser(recaptcha) {
        this.login({
          username: this.model.email,
          password: this.model.password,
          recaptcha: recaptcha
        })
          .then(() => {
            return this.userInfo()
              .then(() => {
                this.$router.push({ name: 'home' });
              });
          }, (e) => {
            this.$refs.recaptcha.reset();
            if (e.response && e.response.data && e.response.data.message) {
              this.error = 'errorMessages.' +  e.response.data.message;
            } else {
              this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
            }
          });
      }
    }
  };
</script>
